import script from "./OrganizationReferralBuilderIntakeForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationReferralBuilderIntakeForm.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationReferralBuilderIntakeForm.vue?vue&type=style&index=0&id=6634a47c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6634a47c"]])

export default __exports__